export default "__VITE_ASSET__Bbkc0Dqi__"